export default __webpack_public_path__ + "static/media/layer3.dcee173c.svg";